import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import { FC, useState } from 'react';

import { useDeleteApplicationNote } from '@features/applicationNotes/hooks/useDeleteApplicationNote';

type DeleteNoteModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  applicationId: number;
  applicationNoteId: number | null;
  clearSelectedNote: () => void;
};

const DeleteNoteModal: FC<DeleteNoteModalProps> = ({
  isOpen,
  handleClose,
  applicationId,
  applicationNoteId,
  clearSelectedNote,
}) => {
  const [errorText, setErrorText] = useState('');

  const { deleteNote, isDeleteNoteLoading } = useDeleteApplicationNote({
    applicationId,
    setErrorText,
  });

  const handleDelete = () =>
    deleteNote(
      { application_note_id: applicationNoteId as number },
      {
        onSuccess: () => {
          clearSelectedNote();
          handleClose();
        },
      },
    );

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete this note?</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={handleDelete}
            loading={isDeleteNoteLoading}
          >
            Delete
          </LoadingButton>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteNoteModal;
